import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { format as formatDate } from 'date-fns';
import { useIoContext } from '~/contexts';
import { useFeatureFlags } from '~/hooks/useFeatureFlags';
import { useLocaleKeys } from '~/i18n';
import { validateBundles, validateDayOfMonth, validateDiscountPeriodExpiration, validateIntegratedClass, validateLimitedTimeDiscountOffer, validateMaxCharges, validateOneTimeInStages, validatePreapprovedAmount, validatePriceIncrease, validateStartBillingAt, validateBillingInitiation, serviceValidationTextsPath } from '../logic';
import { isFromAmendment } from '../selectors';
import { resolveStageScheduleContext } from '../stageScheduleContext';
const resolveScheduleContext = (service, opts)=>({
        context: resolveStageScheduleContext({
            isTemplate: opts.isTemplate,
            isAmendment: isFromAmendment(service),
            effectiveDate: opts.relationshipEffectiveDate,
            now: opts.now
        }),
        effectiveDate: opts.relationshipEffectiveDate ? formatDate(opts.relationshipEffectiveDate, 'yyyy-MM-dd') : null,
        today: formatDate(opts.now, 'yyyy-MM-dd')
    });
export const useValidateService = ()=>{
    const { getNow } = useIoContext();
    const { YEARLY_AUTOMATIC_SERVICE, AUTOMATIC_STAGES } = useFeatureFlags();
    const { t: validationTexts } = useLocaleKeys(serviceValidationTextsPath);
    const validate = (service, opts)=>{
        var _opts_isTemplate;
        const scheduleContext = AUTOMATIC_STAGES ? resolveScheduleContext(service, {
            isTemplate: (_opts_isTemplate = opts.isTemplate) !== null && _opts_isTemplate !== void 0 ? _opts_isTemplate : false,
            relationshipEffectiveDate: opts.relationshipEffectiveDate,
            now: opts.now
        }) : undefined;
        return [
            ...validateMaxCharges(service, validationTexts),
            ...opts.excludeBillingValidation ? [] : validateDayOfMonth(service, validationTexts),
            ...validatePriceIncrease(service, opts, validationTexts),
            ...validateIntegratedClass(service, validationTexts),
            ...validateLimitedTimeDiscountOffer(service, opts.now, validationTexts),
            ...validateOneTimeInStages(service, scheduleContext),
            ...validateDiscountPeriodExpiration(service, opts.now, validationTexts, opts.relationshipEffectiveDate),
            ...validatePreapprovedAmount(service, validationTexts),
            ...validateBundles(service),
            ...validateStartBillingAt(service, opts, validationTexts),
            ...!opts.excludeBillingValidation ? validateBillingInitiation(service, YEARLY_AUTOMATIC_SERVICE, validationTexts) : []
        ];
    };
    return {
        isInvalid: (service, opts)=>{
            const errors = validate(service, _object_spread_props(_object_spread({}, opts), {
                now: getNow()
            }));
            return errors.length > 0;
        }
    };
};
